module.exports = __webpack_public_path__ + "static/add-webhook-automation-6105354c05c9f07a0555a50d3a4827a9.png";